<ng-container *ngIf="viewModel$ | async as vm">
 
  <div class="container is-flex is-fullwidth is-justify-center">
    <div class="is-block">

      <app-text class="text-14 text-grey-70 is-family-semiBold is-justify-center">
        {{'common-app.__HEATING_HOURS' | AsyncLang | async }}
      </app-text>

    <div class="is-flex is-fullwidth is-justify-center">
      <app-text class="is-family-bold text-32"> {{ getHours(vm.hoursSaved) }}</app-text>

      <ng-container *ngIf="vm.hoursSavedPercent > 0">
        <div class="percent-save positive is-flex" >

          <app-text class="text-14 is-family-semiBold"> {{ '+' + vm.hoursSavedPercent + ' %'}}</app-text>
          <app-icon name="small-arrow-up" class="text-20"></app-icon>
        </div>
      </ng-container>

      <ng-container *ngIf="vm.hoursSavedPercent < 0">
        <div class="percent-save negative is-flex" >

          <app-text class="text-14 is-family-semiBold"> {{ vm.hoursSavedPercent + ' %'}}</app-text>
          <app-icon name="small-arrow-down" class="text-20"></app-icon>
        </div>
      </ng-container>
    </div>
  </div>

    
  </div>
    
</ng-container>

